import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import { AppstoreOutlined, FileOutlined } from '@ant-design/icons';
import JsonViewerTwo from './JsonViewer-dataapi';
import JsonViewer from './JsonViewer';
// import PDFViewer from './pdf';
import CsvViewer from './CsvViewer';
import VideoPlayer from './VideoPlayer';
import AudioPlayer from './AudioPlayer';
import {DocumentViewer} from './DocViewer';
import JSONEditorComponent from './JSONEditorComponent';
import SpeechRecognition from './SpeechRecognition';
// import PDFChunkViewer from './PDFChunkViewer';
import Form from './form';
import App from './flow/OrgTree'
import NestedFlow from './flow/NestedFlow'
import ReactiveFlow from './flow/ReactiveFlow'
import LayoutFlow from './flow/LayoutFlow'
import QApp from './qry/customHook'
import MediaDevices from './qry/MediaDevices'
import Repos from './qry/api'
import QueryDePen from './qry/query-dependencies'
import FetchOnDemand from './qry/fetching-on-demand/index'
import DependentQry from './qry/dependent-queries/index'
import PhotoUpload from './upload/PhotoUpload'
import MainReactFlow from './shaderfrogflow/MainComponent'
import HierarchicalFlow from './FlowLevelModel';
import FestoonTree from './festoon-tree/FestoonTree'
import FlowWrapper from './react-flow-domain-thing-model-poc/App';
import RadialTreeRunner from './d3-radialTree/radial-tree/radial-tree-runner';

const { Header, Content, Sider } = Layout;

const MenuComponent: React.FC = () => {
  const [selectedKey, setSelectedKey] = useState('1');
  const initialData = {
    name: 'John Doe',
    age: 30,
    address: {
      street: '123 Main St',
      city: 'Anytown',
      state: 'CA',
    },
  };

  const initialDataFor10Users = Array.from({ length: 10 }, (_, index) => ({
    ...initialData,
    name: `User ${index + 1}`,
  }));

  const [data, setData] = useState(initialDataFor10Users);

  const handleDataChange = (updatedData: any) => {
    setData(updatedData);
    console.log('Updated Data:', updatedData);
  };
  const handleUpload = (croppedImage: string) => {
    console.log('Cropped image uploaded:', croppedImage);
  };

  const renderComponent = () => {
    switch (selectedKey) {
      // case '1':
      //   return <PDFViewer />;
      // case '9':
      //   return <PDFChunkViewer />;
      case '2':
        return <JsonViewer />;
      case '3':
        return <CsvViewer url="https://viewer-json-api-558926418263.us-central1.run.app/csv"  />;
      case '4':
        return <VideoPlayer videoUrl='https://viewer-json-api-558926418263.us-central1.run.app/video' />;
      case '5':
        return <AudioPlayer audioUrl='https://viewer-json-api-558926418263.us-central1.run.app/audio' />;
      case '6':
        return <JSONEditorComponent initialData={data} onChange={handleDataChange} />;
      case '7':
        return <SpeechRecognition />;
      case '8':
        return <JsonViewerTwo />;
      case '10':
        return <Form />;
      case '11':
        return <App />
      case '12':
        return <NestedFlow />
      case '13':
        return <ReactiveFlow />
      case '14':
        return <LayoutFlow />
      case '15':
        return <QApp />
      case '16':
        return <MediaDevices />
      case '17':
        return <Repos />
      case '18':
        return <QueryDePen />
      case '19':
        return <FetchOnDemand />
      case '20':
        return <DependentQry />
      case '21':
        return <PhotoUpload  />
      case '22':
        return <MainReactFlow />
      case '23':
        return <HierarchicalFlow />
      case '24':
        return <FestoonTree />
      case '25':
        return <FlowWrapper />
      case '26':
        return <RadialTreeRunner />
      default:

    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        width={200}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <Menu
          theme="dark"
          defaultSelectedKeys={['3']}
          mode="inline"
          onClick={(e) => setSelectedKey(e.key)}
        >
          {/* <Menu.Item key="1" icon={<FileOutlined />}>
            PDF Viewer
          </Menu.Item> */}
          <Menu.Item key="3" icon={<AppstoreOutlined />}>
            CSV Viewer
          </Menu.Item>
          <Menu.Item key="4" icon={<AppstoreOutlined />}>
            Video Player
          </Menu.Item>
          <Menu.Item key="5" icon={<AppstoreOutlined />}>
            Audio Player
          </Menu.Item>
          <Menu.Item key="6" icon={<AppstoreOutlined />}>
            JSON Editor 
          </Menu.Item>
          <Menu.Item key="7" icon={<AppstoreOutlined />}>
            Speech Recognition
          </Menu.Item>
          <Menu.Item key="8" icon={<AppstoreOutlined />}>
            JSON Viewer
          </Menu.Item>
         
   
          <Menu.Item key="12" icon={<AppstoreOutlined />}>
            Nested Flowchart
          </Menu.Item>
          <Menu.Item key="13" icon={<AppstoreOutlined />}>
            Reactive Flowchart
          </Menu.Item>
          <Menu.Item key="14" icon={<AppstoreOutlined />}>
            Layout Flowchart
          </Menu.Item>
        
         
          <Menu.Item key="21" icon={<AppstoreOutlined />}>
          Photo Upload
          </Menu.Item>

          <Menu.Item key="22" icon={<AppstoreOutlined />}>
          React Flow
          </Menu.Item>

          <Menu.Item key="23" icon={<AppstoreOutlined />}>
          Hierarchical Flow

        </Menu.Item>
        <Menu.Item key="24" icon={<AppstoreOutlined />}>
          Festoon Tree
        </Menu.Item>

        <Menu.Item key="25" icon={<AppstoreOutlined />}>
          Thing Model React Flow Diagram
        </Menu.Item>

        <Menu.Item key="26" icon={<AppstoreOutlined />}>
          D3 Radial Tree
        </Menu.Item>

        </Menu>
      </Sider>
      <Layout style={{ marginLeft: 200 }}>
        <Content style={{ margin: '16px' }}>
          {renderComponent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MenuComponent;
